module.exports = __webpack_public_path__ + "img/operators.3cd4eddb.svg";